import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { BalanceHistoryType, IBalanceHistory } from 'interfaces/balance';
import { getBalanceHistory } from 'services/balance';
import Card from 'components/Card';
import InputDate from 'components/Input/InputDate';
import Select from 'components/Input/Select';
import { IOption } from 'components/Input/Select/types';
import classes from './balanceHistory.module.scss';

const COLUMNS: { [key: string]: string } = {
	date: 'Время платежа',
	paymentSum: 'Сумма платежа',
	paymentType: 'Тип платежа',
	balanceSum: 'Тип баланса'
};

const PAYMENT_TYPES_OPTIONS = [
	{ value: 'all', label: 'Все' },
	{ value: 'write-off', label: 'Списание' },
	{ value: 'refill', label: 'Пополнение' },
];

const BalanceHistory: React.FC = () => {
	const [balanceHistory, setBalanceHistory] = useState<IBalanceHistory[]>([]);
	const [startDate, setStartDate] = useState<Date | null>(null);
	const [endDate, setEndDate] = useState<Date | null>(null);
	const [selectedPaymentType, setSelectedPaymentType] = useState<IOption | null>(PAYMENT_TYPES_OPTIONS[0]);
	const [isLoading, setIsLoading] = useState(false);

	const getBalanceData = async (): Promise<void> => {
		if (isLoading) return;

		setIsLoading(true);
		try {
			const { data: newBalanceHistory = [] } = await getBalanceHistory();
			setBalanceHistory([])
		} catch (err) {
			toast.error('Не удалось загрузить историю баланса');
		}
		setIsLoading(false);
	};

	useEffect(() => {
		getBalanceData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleSetSelectedDates = (dates: (Date | null)[]) => {
		const [start, end] = dates;
		setStartDate(start);
		setEndDate(end);
	}

	const filters = (
		<div className={classes.filters}>
			<InputDate
				className={classes.filter}
				startDate={startDate}
				endDate={endDate}
				onChange={handleSetSelectedDates}
				placeholder="Период"
			/>
			<Select
				className={classes.filter}
				value={selectedPaymentType}
				options={PAYMENT_TYPES_OPTIONS}
				onSelect={setSelectedPaymentType}
				placeholder="Тип операции"
			/>
		</div>
	);

	const tableHeader = (
		<div className={classes.tableHeader}>
			{Object.keys(COLUMNS).map((header: string) => (
				<div className={classes.tableHead} key={header}>
					{COLUMNS[header]}
				</div>
			))}
		</div>
	);

	const tableBody = (
		<div className={classes.tableBody}>
			{balanceHistory.map((balanceHistoryItem) => (
				<div className={classes.tableRow} key={balanceHistoryItem.id}>
					{Object.keys(COLUMNS).map((column: string) => (
						<div className={classes.tableColumn} key={column}>
							{balanceHistoryItem[column as BalanceHistoryType]}
						</div>
					))}
				</div>
			))}
		</div>
	);

	const table = (
		<div className={classes.table}>
			{tableHeader}
			{tableBody}
		</div>
	);

	return (
		<div className={classes.balanceHistory}>
			<div className={classes.title}>История операций</div>
			{filters}
			<Card className={classes.content}>
				{table}
			</Card>
		</div>
	);
};

export default BalanceHistory;
